var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorWhiteSizeLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 55,
    viewBox: "0 0 220 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_9887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.754883 54.6582V0.637817H20.1703V38.4522H48.2006V54.6582H0.754883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.369 54.6582V0.637817H122.613L138.171 27.455H139.972V0.637817H158.937V54.6582H137.143L121.07 27.8409H119.335V54.6582H100.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0511 26.6271L98.363 0.637817H77.9832L73.2509 9.13007L79.9073 21.075L83.0511 26.6271ZM76.3117 38.0663V54.6582H56.8319V37.8733L34.8447 0.637817H55.2889L65.8967 19.6736L76.3117 38.0663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.241 27.7123L157.726 54.6582H178.877L187.557 40.5101H189.421L198.1 54.6582H213.582L187.557 14.0143L179.07 0.637817H158.241L176.241 26.7478V27.7123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.843 0.637817H218.737L207.893 16.4794L206.066 19.1485L196.053 3.48297L197.843 0.637817Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_9887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 54.6584,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorWhiteSizeLarge);
export default __webpack_public_path__ + "static/media/Color=White, Size=Large.0b72e7502483b27fcd14e990596fda0d.svg";
export { ForwardRef as ReactComponent };